/**
 * "Look at my passport now" — fired after a saved activity, so a newly
 * unlocked country gets its stamp right away (DECISIONS #101). The global
 * `PassportStampHost` listens; it also checks on app start and when the app
 * comes back to the foreground, so background saves are covered too.
 */
import { getDateTag } from '@/i18n';

export const PASSPORT_CHECK_EVENT = 'grundo:passport-check';

export function requestPassportCheck(): void {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(PASSPORT_CHECK_EVENT));
}

/** Stamp date, e.g. "14 OCT 2026" / "2026. OKT. 14." — upper case like ink. */
export function formatStampDate(ms: number): string {
  return new Intl.DateTimeFormat(getDateTag(), { year: 'numeric', month: 'short', day: '2-digit' })
    .format(ms)
    .toUpperCase();
}
